import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Λείπει το εναλλακτικό κείμενο για αυτήν την εικόνα',
    noAnswers: 'Δεν υπάρχει επιλογή απάντησης, κάντε κλικ στο επόμενο για να συνεχίσετε.',
    placeholder: 'Παρακαλώ προσδιορίστε...',
    pleaseSelect: 'Παρακαλώ επιλέξτε...',
    rotateLandscape: 'Απενεργοποιήστε τον κλείδωμα προσανατολισμού στο τηλέφωνό σας και περιστρέψτε το σε οριζόντια θέση για να συνεχίσετε.',
    rotatePortrait: 'Περιστρέψτε το τηλέφωνό σας από την οριζόντια στην κατακόρυφη θέση για να συνεχίσετε.',
    ir: {
      selectWebCam:
        'Επιλέξτε την κάμερα (αν υπάρχει) ή κάντε κλικ στο «Αναζήτηση» για να ανεβάσετε από τη συσκευή σας.',
      uploadOnly: 'Επιλέξτε την κάμερα (αν υπάρχει) ή κάντε κλικ στο «Αναζήτηση» για να ανεβάσετε από τη συσκευή σας.',
      noWebCam: 'Δεν εντοπίστηκε κάμερα',
      accessCamUpload: 'ΠΡΟΣΒΑΣΗ ΣΤΗΝ ΚΑΜΕΡΑ/ΜΕΤΑΦΟΡΤΩΣΗ',
      browse: 'ΠΕΡΙΗΓΗΣΗ',
      uploadPhoto: 'Ανεβάστε μια φωτογραφία',
      camera: 'Διαδικτυακή Κάμερα',
      instead: 'αντί να την',
      capture: 'ΤΡΑΒΗΞΕΤΕ',
      somethingWrong: 'Λυπάμαι, κάτι πήγε στραβά. Προσπαθήστε ξανά αργότερα',
      couldntRead: 'Λυπάμαι, δεν μπορέσαμε να διαβάσουμε τον κωδικό!',
      couldntProcess: 'Λυπάμαι, δεν μπορέσαμε να επεξεργαστούμε την εικόνα σας!',
      inValidCode: 'Παρακαλώ, υποβάλετε τον έγκυρο κωδικό',
      moveOn: 'Προσπαθήστε ξανά ή στείλτε τη φωτογραφία σας και συνεχίστε',
      tryAgain: 'Προσπαθήστε ξανά',
      dataReceived: 'Data received!',
      enterManually: 'Προσπαθήστε ξανά ή εισάγετε τα δεδομένα χειροκίνητα παρακάτω',
      positionQR:
        'Τοποθετήστε τον κωδικό QR μπροστά από την κάμερά σας για να χωρέσει στο κόκκινο πλαίσιο ή ανεβάστε τον από τον υπολογιστή σας.',
      positionQRMobile: 'Τοποθετήστε τον κωδικό QR μπροστά από την κάμερά σας ή ανεβάστε τον από την συσκευή σας.',
      analyzing: 'Ανάλυση εικόνας, παρακαλώ περιμένετε',
      submit: 'ΥΠΟΒΟΛΗ',
      startOver: 'Ξεκινήστε',
      allDone: 'Όλα εντάξει!',
      cantAnalyze:
        'Προσοχή - δεν μπορέσαμε να εμφανίσουμε αυτή την εικόνα. Προσπαθήστε να επαναλάβετε την υποβολή ή επιλέξτε μια πιο γενική μορφή εικόνας. (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Λυπούμαστε - δεν υποστηρίζουμε αυτή τη μορφή αρχείου. Μεταφορτώστε έναν υποστηριζόμενο τύπο εικόνας (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Δεν εντοπίστηκε κάμερα',
      uploadVideo: 'Ανεβάστε ένα βίντεο',
      skip: 'Παράλειψη;',
      accessCamUpload: 'ΠΡΟΣΒΑΣΗ ΣΤΗΝ ΚΑΜΕΡΑ/ΜΕΤΑΦΟΡΤΩΣΗ',
      browse: 'ΠΕΡΙΗΓΗΣΗ',
      instead: 'αντί να την',
      or: 'ή',
      stopRecording: 'Διακοπή της καταγραφής',
      willBeStopped: 'Η καταγραφή θα σταματήσει σε <b>5 λεπτά</b>',
      stopOnDone: 'Σταματήστε την καταγραφή όταν τελειώσετε!',
      record: 'ΚΑΤΑΓΡΑΦΗ',
      somethingWrong: 'Λυπάμαι, κάτι πήγε στραβά. Προσπαθήστε ξανά αργότερα.',
      dataReceived: 'Τα δεδομένα ελήφθησαν!',
      microphone: 'μικρόφωνο',
      camera: 'Διαδικτυακή Κάμερα',
      selectMicrophone: 'Παρακαλώ επιλέξτε микрофон',
      selectCam: 'Παρακαλώ επιλέξτε уебкамера',
      submit: 'ΥΠΟΒΟΛΗ',
      upload: 'Ανεβάστε',
      playback: 'Αναπαραγωγή',
      stopPlayback: 'ΔΙΑΚΟΠΗ ΤΗΣ ΑΝΑΠΑΡΑΓΩΓΗΣ',
      startOver: 'Ξεκινήστε',
      allDone: 'Όλα εντάξει!',
      alternativeRecordSpan:
        'Παρακαλούμε, ανεβάστε ένα βίντεο από τον υπολογιστή σας. <br/>Εναλλακτικά, μπορείτε να καταγράψετε το βίντεο με μια κάμερα. &nbsp;',
      alrenativeRecordHref: 'καταγράψετε το βίντεο με μια κάμερα.',
      cantAnalyze:
        'Προσοχή - δεν μπορέσαμε να εμφανίσουμε αυτό το βίντεο. Προσπαθήστε να επαναλάβετε την υποβολή ή επιλέξτε μια πιο γενική μορφή βίντεο (MP4, M4V, WEBPM)',
      wrongFormat:
        'Λυπούμαστε - δεν υποστηρίζουμε αυτή τη μορφή αρχείου. Μεταφορτώστε έναν υποστηριζόμενο τύπο βίντεο (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'ΕΠΙΛΕΞΤΕ',
      pleaseChoose: 'Παρακαλώ επιλέξτε',
      this: 'Αυτό',
      one: ' από εδώ',
      myChoice: 'Η ΕΠΙΛΟΓΗ ΜΟΥ'
    },
    hm: {
      addComment: 'Προσθέστε ένα σχόλιο παρακάτω',
      commentMandatoryPlaceHolder: 'Προσθέστε υποχρεωτικά ένα σχόλιο... ',
      commentOptionalPlaceHolder: 'Προσθέστε προαιρετικά ένα σχόλιο... ',
      dragPin: 'Σύρετε για επανατοποθέτηση (παρατεταμένο κλικ/πατήστε στην ακίδα με ακρίβεια).',
      removePin: 'Σύρετε έξω από την εικόνα για διαγραφή.  ',
      editComment: 'Κάντε κλικ/πατήστε στην ακίδα για να επεξεργαστείτε το σχόλιο.',
      addPin:
        'Σύρετε την ακίδα από τον παρακάτω πίνακα και αφήστε την σε ένα σημείο της επιλογής σας επάνω στην εικόνα.',
      addPins:
        'Σύρετε τις ακίδες από τον παρακάτω πίνακα και αφήστε τις σε ένα σημείο της επιλογής σας επάνω στην εικόνα. ',
      leavePins: (minPoints, maxPoints) =>
        `Αφήστε τουλάχιστον ${minPoints}, αλλά όχι περισσότερες από ${maxPoints} ακίδες κάθε είδους.`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Αφήστε τουλάχιστον ${minPoints}, αλλά όχι περισσότερες από ${maxPoints} ακίδες κάθε είδους.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Αφήστε τουλάχιστον ${minPoints}, αλλά όχι περισσότερες από ${maxPoints} ακίδες.`,
      leavePinsWithOff: maxPoints =>
        `Αφήστε το πολύ ${maxPoints} ακίδες κάθε είδους ή κάντε κλικ στο κουμπί Επόμενο για παράλειψη.`,
      leavePinsWithOffAny: maxPoints =>
        `Αφήστε το πολύ ${maxPoints} ακίδες κάθε είδους ή κάντε κλικ στο κουμπί Επόμενο για παράλειψη`,
      leavePinsPerPageWithOff: maxPoints =>
        `Αφήστε το πολύ ${maxPoints} ακίδες ή κάντε κλικ στο κουμπί Επόμενο για παράλειψη.`,
      leavePinWithOff: `Αφήστε το πολύ 1 ακίδα κάθε είδους ή κάντε κλικ στο κουμπί Επόμενο για παράλειψη.`,
      leavePinWithOffAny: `Αφήστε το πολύ 1 ακίδα κάθε είδους ή κάντε κλικ στο κουμπί Επόμενο για παράλειψη`,
      leavePinPerPageWithOff: 'Αφήστε το πολύ 1 ακίδα ή κάντε κλικ στο κουμπί Επόμενο για παράλειψη',
      leaveExactlyPin: `Αφήστε 1 ακίδα κάθε είδους.`,
      leaveExactlyPinAny: `Αφήστε 1 ακίδα κάθε είδους.`,
      leaveExactlyPinPerPage: 'Αφήστε 1 ακίδα. ',
      leaveExactlyPins: maxPoints => `Αφήστε ${maxPoints} ακίδες κάθε είδους.`,
      leaveExactlyPinsAny: maxPoints => `Αφήστε ${maxPoints} ακίδες κάθε είδους.`,
      leaveExactlyPinsPerPage: maxPoints => `Αφήστε ${maxPoints} ακίδες.`,
      leaveComment: 'Πληκτρολογήστε κάτω από την εικόνα για να αφήσετε ένα σχόλιο.',
      noAnswers: 'Δεν υπάρχει επιλογή απάντησης, κάντε κλικ στο επόμενο για να συνεχίσετε.',
      outOfPins: 'Έχετε ξεμείνει από ακίδες',
      pinsBehavior: 'Καθώς μετακινείστε σε όλη την εικόνα, θα δείτε περιοχές που θα επισημαίνονται με μια απλή ακίδα.',
      clusters: 'Θα μπορείτε να τοποθετήσετε τις ακίδες μόνο σε αυτές τις επισημασμένες περιοχές.',
      contentAware: 'Μπορείτε να τοποθετήσετε τις ακίδες μέσα ή έξω από τις επισημασμένες περιοχές.'
    },
    mp: {
      expand_note: 'Περάστε με το ποντίκι ή κάντε κλικ στην εικόνα(ες) για επέκταση.',
      rb_note: rows => `Παρακαλώ επιλέξτε μόνο 1 απάντηση ανά στοιχείο${rows ? ' παρακάτω' : ''}:`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `Παρακαλώ επιλέξτε ${min !== 1 ? 'οποιαδήποτε' : 'μόνο'} ${min} ${
            min !== 1 ? 'απαντήσεις ' : 'απάντηση'
          } ανά στοιχείο${rows ? ' παρακάτω' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Παρακαλούμε επιλέξτε τουλάχιστον ${min} ${
            min !== 1 ? 'απαντήσεις ' : 'απάντηση'
          } αλλά όχι περισσότερα από ${max} ανά στοιχείο${rows ? ' παρακάτω' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Παρακαλούμε επιλέξτε τουλάχιστον ${min} ${min !== 1 ? 'απαντήσεις ' : 'απάντηση'} ανά στοιχείο${
            rows ? ' παρακάτω' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Παρακαλούμε επιλέξτε όχι περισσότερα από ${max} ${
            max !== 1 ? 'απαντήσεις ' : 'απάντηση'
          } ανά στοιχείο${rows ? ' παρακάτω' : ''}:`
        } else {
          return 'Επιλέξτε όλα όσα ισχύουν:'
        }
      }
    },
    sh: {
      note: 'Κάντε κλικ σε ένα προϊόν για να το μεγεθύνετε και να το προσθέσετε στο εικονικό σας καλάθι, αν το αγοράζατε στο κατάστημα.',
      amazonNote: 'Κάντε κλικ σε ένα προϊόν για να το μεγεθύνετε και να το προσθέσετε στο εικονικό σας καλάθι.',
      fullCart: 'Το καλάθι σας είναι γεμάτο!',
      qty: 'ΠΟΣΟΤΗΤΑ',
      addToCart: 'ΠΡΟΣΘΗΚΗ ΣΤΟ ΚΑΛΑΘΙ',
      deleteFromCart: 'ΔΙΑΓΡΑΦΗ',
      each: 'καθε',
      items: 'είδη',
      emptyCard: 'Το καλάθι σας είναι άδειο',
      total: 'Καλάθι',
      clearCart: 'Διαγραφή καλαθιού',
      backToStore: 'Πίσω στο κατάστημα',
      scrollError: `Κάντε κύλιση πλήρως προς τα αριστερά και προς τα δεξιά για να προχωρήσετε στην έρευνα. `,
      na: 'Τίποτα από τα παραπάνω',
      next: 'ΕΠΟΜΕΝΟ'
    },
    rb: {
      note: 'Παρακαλώ επιλέξτε μόνο 1 στοιχείο'
    },
    vo: {
      note: 'Παρακολουθήστε το βίντεο μέχρι το τέλος'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'Επιλέξτε όλα όσα ισχύουν:'
        } else if (min === max) {
          return `Παρακαλώ επιλέξτε ${min !== 1 ? 'επακριβώς' : 'μόνο'} ${min} στοιχεί${min !== 1 ? 'α' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Παρακαλώ επιλέξτε τουλάχιστον ${min} στοιχεί${
            min !== 1 ? 'α' : ''
          }, αλλά όχι περισσότερες από ${max}:`
        } else if (5000 === max && min > 0) {
          return `Παρακαλώ επιλέξτε τουλάχιστον ${min} στοιχεί${min !== 1 ? 'α' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Παρακαλώ επιλέξτε όχι περισσότερα από ${max} στοιχεί${max !== 1 ? 'α' : ''}:`
        } else {
          return 'Επιλέξτε όλα όσα ισχύουν:'
        }
      }
    },
    oe: {
      na: 'Δεν εφαρμόζεται',
      note: (min, max, optional) => {
        if (min === max) {
          return `Πληκτρολογήστε ${1 !== min ? 'επακριβώς' : 'οποιουσδήποτε'} ${min} χαρακτήρε${1 !== min ? 'α' : ''}${
            optional ? ' (προαιρετικά)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Πληκτρολογήστε τουλάχιστον ${min} χαρακτήρε${1 !== min ? 'α' : ''} αλλά όχι περισσότερες από ${max}${
            optional ? ' (προαιρετικά)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Πληκτρολογήστε τουλάχιστον ${min} χαρακτήρε${1 !== min ? 'α' : ''}${
            optional ? ' (προαιρετικά)' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Πληκτρολογήστε όχι περισσότερα από ${max} χαρακτήρε${1 !== min ? 'α' : ''}${
            optional ? ' (προαιρετικά)' : ''
          }:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Συμπληρώστε τα ακόλουθα πεδία:'
    },
    mx: {
      note: 'Μετακινήστε τα επισημασμένα ρυθμιστικά για να συνεχίσετε',
      dragSlider: 'Σύρετε αριστερά ή δεξιά για να απαντήσετε'
    },
    psc: {
      dragLeftRight: 'Σύρετε αριστερά ή δεξιά για να απαντήσετε'
    },
    ps: {
      note: value => `Κατανείμετε το ${value} μεταξύ των παρακάτω στοιχείων`,
      allDone: `Όλα εντάξει!`,
      total: `σύνολο:`,
      dragSlider: 'Σύρετε αριστερά ή δεξιά για να απαντήσετε'
    },
    cx: {
      note: 'Ανοίξτε το πλαίσιο επιλογών και αρχίστε να πληκτρολογείτε την απάντησή σας στην αυτόματη κύλιση ή επιλέξτε την χειροκίνητα'
    },
    ro: {
      note: 'Σύρετε προς τα πάνω ή προς τα κάτω για αναδιάταξη:'
    },
    md: {
      note1:
        'Κάντε κλικ/πατήστε στο στοιχείο της πρώτης <b>σας επιλογής</b>.<br/>' +
        ' Κάντε κλικ/πατήστε ξανά για να ακυρώσετε την επιλογή.',
      note2:
        'Τώρα κάντε κλικ/πατήστε στο στοιχείο της τελευταίας <b>σας επιλογής</b>.<br/>' +
        ' Κάντε κλικ/πατήστε ξανά για να ακυρώσετε την επιλογή.',
      note3:
        'Ευχαριστούμε! Συνεχίστε στην επόμενη ερώτηση ή κάντε κλικ/πατήστε σε οποιοδήποτε μη επιλεγμένο στοιχείο για να ξεκινήσετε από την αρχή.'
    },
    aro: {
      note: 'Επιλέξτε ένα στοιχείο από κάθε ζεύγος.'
    },
    wd: {
      note: 'Βεβαιωθείτε ότι κάθε επόμενη τιμή είναι μεγαλύτερη από την προηγούμενη.'
    },
    emd: {
      note: 'Παρακολουθήστε το βίντεο μέχρι το τέλος',
      noAnswers: 'Δεν υπάρχει επιλογή απάντησης, κάντε κλικ στο επόμενο για να συνεχίσετε.',
      start: 'Κάντε κλικ και κρατήστε το πατημένο για να ξεκινήσετε',
      resume: 'Κάντε κλικ και κρατήστε το πατημένο για να συνεχίσετε',
      continue: 'Είστε έτοιμοι! <br />Κάντε κλικ <strong>Επόμενο</strong> για να συνεχίσετε',
      continueMobile: 'Είστε έτοιμοι! <br />Κάντε κλικ <strong>ΕΔΩ</strong> για να συνεχίσετε',
      training: {
        session: 'Εκπαιδευτική συνεδρία',
        note: 'Παρακαλώ ολοκληρώστε την εκπαίδευση',
        moveLeft: 'Σύρετε τον επιλογέα μέχρι τέρμα προς τα αριστερά',
        moveBottom: 'Σύρετε τον επιλογέα μέχρι κάτω',
        moveRight: 'Τώρα, σύρετε τον επιλογέα μέχρι τέρμα προς τα δεξιά',
        moveTop: 'Τώρα, σύρετε τον επιλογέα προς τα επάνω',
        success: 'Μπράβο!'
      }
    },
    sft: {
      noAnswers: 'Δεν υπάρχει επιλογή απάντησης, κάντε κλικ στο επόμενο για να συνεχίσετε.',
      note: 'Απαντήστε όσο πιο γρήγορα μπορείτε με την απάντηση που αισθάνεστε διαισθητικά ως σωστή.',
      finish: 'Είστε έτοιμοι! <br /> Κάντε κλικ Επόμενο για να συνεχίσετε.',
      training: {
        start:
          '<p>Αυτή η ερώτηση θα σας εμφανίσει γρήγορα διάφορες λέξεις και θα απαιτήσει τη συγκέντρωσή σας. ' +
          'Θα πρέπει να αντιδράσετε γρήγορα για να απαντήσετε. </p> <p>Έτοιμοι για εξάσκηση;</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Πατήστε στο "{buttonLeft}"`
            : (mouse ? `Κάντε κλικ "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Πατήστε στο πλήκτρο "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Πατήστε στο "{buttonRight}"`
            : (mouse ? `Κάντε κλικ "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Πατήστε στο πλήκτρο "{keyBtnRight}"` : ''),
        fail: () => 'Πολύ αργά',
        success: () => 'Μπράβο!',
        finish: () =>
          '<p><strong> Εξαιρετικά!</strong></p><p>Βεβαιωθείτε ότι δεν πρόκειται να σας αποσπάσουν την προσοχή για τα επόμενα 2-3 λεπτά. <br />' +
          '</p><p>Κάντε κλικ στο Επόμενο για να ξεκινήσετε όταν είστε έτοιμοι</p>'
      },
      buttons: {
        start: 'Εκκίνηση',
        yesno: {
          left: 'Ναί',
          right: 'όχι'
        },
        matches: {
          left: 'Ταιριάζει',
          right: 'Δεν Ταιριάζει'
        },
        fits: {
          left: 'Ισχύει',
          right: 'Δεν Ισχύει'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        },
        noyes: {
          left: 'Ναί',
          right: 'όχι'
        },
        matchesRev: {
          left: 'Ταιριάζει',
          right: 'Δεν Ταιριάζει'
        },
        fitsRev: {
          left: 'Ισχύει',
          right: 'Δεν Ισχύει'
        },
        thumbsRev: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
